export default __webpack_public_path__ + "static/media/sharpTickIcon.17cac63a.svg";